export default __webpack_public_path__ + "static/media/2485.0c3b3107.png";